import type { FaireProductEntity } from "../../entity_types/product";

export const p_4fq2vgm8nb: FaireProductEntity = {
  token: "p_4fq2vgm8nb",
  type: "product",
  name: "Shower Steamer/ Bath Bombs (Hotels/ Events/ Weddings/ Spas)",
  brandToken: "b_ycglj02w",
  brandName: "Even Keel",
  imageUrl:
    "https://cdn.faire.com/fastly/502ae3b85df0313602c043fbc7f011a787c889596b5d25470cee169c624e6703.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cd6851de6927c05d1584dd047fede758ada13688a4abbf87d2f26b5809b0959a.webp",
    "https://cdn.faire.com/fastly/7b1471668829cd33cc1a5346f1256d114cd1f04876c79199b267c9682c808791.jpeg",
    "https://cdn.faire.com/fastly/8d52ba597d6f39e121e21d4267308a4a3917630cea4a51973361b175d256e8d9.jpeg",
    "https://cdn.faire.com/fastly/c3a16e39452b39ef2bfd214fa9079611eaade25016e457ba93b8935e1b6dd605.jpeg",
    "https://cdn.faire.com/fastly/4fcb6dd742b873aecfdb46c47c2c90dbb4f0a135671d5b2f48acdcd01e73c3dc.jpeg",
    "https://cdn.faire.com/fastly/7cf5ae41746cbf3842e0547cd6fe9f47ea4dcf00a3bf7dce03ec40f37979a4ce.jpeg",
    "https://cdn.faire.com/fastly/b15bc28f87686107dcef4ca79ba087116ae93f43641f8105901dd4f02347dc1a.jpeg",
    "https://cdn.faire.com/fastly/ecaffe0b80de3d67c31b290dcd67bb5bb6febca2d44143439f78570fabaf6657.jpeg",
    "https://cdn.faire.com/fastly/196506d96842ce9d1fe4184f717c52fc66c961fbcc79c2f28d2cc75e0025e6d5.jpeg",
    "https://cdn.faire.com/fastly/5dd518d5ab81d3d09357a57b3760af7514e8750dc684b3fecdd00d3d30d9409c.jpeg",
    "https://cdn.faire.com/fastly/7440d177ca56d2231efeb1990d182a179ad976428647aae9168ce370da666a81.jpeg",
  ],
  priceDollars: 3.2,
  description:
    "***Product update*** All our cubes come individually boxed.\n\nEssential oil blends (in order of slideshow sequence):\n\n• CITRON: Lemon, Sweet Orange\n• JAIPUR: Clove Bud, Cinnamon\n• NAMIB: Lemongrass, Sweet Orange\n• SAPA: Cedarwood, Peppermint\n• CAPPA: Lavender, Cedarwood\n• WOODS: Cedarwood, Pine\n• PETRA: Clove Bud, Patchouli\n• UYUNI: Rosemary, Peppermint\n• FLORAL: Lavender, Cedarwood",
  tags: [],
  msrpDollars: 7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:19.148Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
